
/**
 * Custom component for Bimini food items.
 *
 * @author Jasper Howard <jhoward@peppermillcas.com>
 * @version 1.1.1
 * @copyright  Copyright (C) 2023-2025, Peppermill Inc. All rights reserved. Redistribution and use in source and binary forms, with or without modification, are not permitted.
 *
 *    2023-06-07 (1.0.0) (jhoward)
 *      - <biminiFoodItem> copied to <panchoWilliesFoodItem>.
 *
 *    2023-06-21 (1.1.0) (jhoward)
 *      - Add `priceLayout` prop in <panchoWilliesFoodItem>.
 *
 *    2025-04-08 (1.1.1) (jhoward)
 *      - Remove "visual_" prefix from class names in <panchoWilliesFoodItem>.
 */

import {defineComponent, PropType} from "vue";
import {MenuItem} from "../defs";
import DefaultItem from "./defaultItem.vue";

export default defineComponent({
  name: 'pancho-willies-food-item',
  components: {
    DefaultItem
  },
  props: {
    item: {
      type: Object as PropType<MenuItem>,
      required: true
    },
    pricingTypes: {
      type: Array as PropType<string[]>,
      default: () => []
    },
    priceLayout: {
      type: String as PropType<'price-inline' | 'price-below'>,
      default: 'price-inline'
    }
  },
})
